import { Component, inject } from '@angular/core';
import { ButtonModule } from '@primeng/button';
import { FileInputComponent } from '@shared/components/file-input/file-input.component';
import { FormSkeletonComponent } from '@common/components/form-skeleton/form-skeleton.component';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import urlJoin from 'url-join';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { RoleService } from '@common/rbac/role.service';
import { Roles } from '@common/rbac/roles';
import { CompaniesService } from '@modules/universal-billing/companies/companies.service';
import { AuthService } from '@app/auth/auth.service';

@Component({
  selector: 'app-booking-import',
  standalone: true,
  imports: [
    ButtonModule,
    FileInputComponent,
    FormSkeletonComponent,
    ReactiveFormsModule,
    TranslatePipe,
    AutocompleteComponent,
    InputValidatorDirective
  ],
  templateUrl: './booking-import.component.html',
  styleUrl: './booking-import.component.scss'
})
export class BookingImportComponent extends BasicForm<any> {
  _defaultService = inject(DefaultService);
  form: FormGroup;
  _http = inject(HttpClient)
  companyService = inject(CompaniesService);
  authService = inject(AuthService);
  protected readonly RoleService = RoleService;
  protected readonly Roles = Roles;

  ngOnInit() {
    super.ngOnInit();
    const isAdminOrGroupManager = [Roles.ADMIN, Roles.COMPANY_GROUP_MANAGER].includes(RoleService.currentRole);
    this.form = this._fb.group({
      csv_file: ['', Validators.required],
      companyId: [isAdminOrGroupManager ? null : this.authService.userData()?.companyId, isAdminOrGroupManager ? Validators.required : []],
    })
  }

  override convertToRequestData(data: any): any {
    const dto = new FormData();
    dto.append('csv_file', data.csv_file);
    dto.append('company_id', data.companyId);
    return dto
  }

  override submitAction(data) {
    return this._http.post(urlJoin(environment.apiUrl, 'datevbookings/import'), data);
  }

  afterSuccessSubmit(res: any) {
    this.isPending.set(false);
    this._modalService.close(ModalClose.SUCCESS);
    this.sweetAlertService.success(this.translateService.instant('BOOKINGS.IMPORT_FILE_RESPONSE', res.data), "BOOKING.UPLOADED")
  }

  afterErrorSubmit(res: HttpErrorResponse) {
    this.isPending.set(true);
    this.sweetAlertService.error('', res.error?.message)
    super.afterErrorSubmit(res);
  }

  getCompanies(params: any) {
    return this.companyService.getActiveAll(params);
  }
}

